const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  statusCard: {
    padding: '16px 20px',
    borderRadius: '12px',
    backgroundColor: '#F8FAFC',
    border: '1px solid #E2E8F0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  browserContainer: {
    border: '1px solid #E2E8F0',
    borderRadius: '12px',
    overflow: 'hidden',
    backgroundColor: '#FFFFFF',
  },
  breadcrumb: {
    padding: '12px 16px',
    backgroundColor: '#F8FAFC',
    borderBottom: '1px solid #E2E8F0',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexWrap: 'wrap',
    fontSize: '14px',
  },
  breadcrumbItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    color: '#64748B',
    cursor: 'pointer',
    '&:hover': {
      color: '#0F172A',
    },
  },
  breadcrumbCurrent: {
    fontWeight: 600,
    color: '#0F172A',
  },
  folderList: {
    maxHeight: '400px',
    overflowY: 'auto',
  },
  folderItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    gap: '12px',
    borderBottom: '1px solid #F1F5F9',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: '#F8FAFC',
    },
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  folderIcon: {
    color: '#F59E0B',
  },
  fileName: {
    flex: 1,
    fontSize: '14px',
    color: '#1E293B',
    fontWeight: 500,
  },
  selectionInfo: {
    padding: '24px',
    borderRadius: '12px',
    backgroundColor: '#F0F9FF',
    border: '1px solid #BAE6FD',
  },
  fileChip: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #E2E8F0',
    borderRadius: '8px',
    padding: '6px 10px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    margin: '4px',
    fontSize: '12px',
    color: '#475569',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  },
  '@keyframes pop': {
    '0%': { transform: 'scale(1)' },
    '40%': { transform: 'scale(0.85)' },
    '70%': { transform: 'scale(1.1)' },
    '100%': { transform: 'scale(1)' },
  },
  animating: {
    animation: '$pop 350ms ease-in-out',
  },
  continueButton: {
    width: 56,
    height: 56,
    backgroundColor: '#3B82F6',
    color: '#FFFFFF',
    borderRadius: '50%',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: '#2563EB',
      transform: 'scale(1.05) translateX(4px)',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    },
    '&.Mui-disabled': {
      backgroundColor: '#E2E8F0',
      color: '#94A3B8',
      boxShadow: 'none',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '28px',
    },
  },
})

export default styles
